
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { createTypedSupabaseClient } from './customTypes';

const SUPABASE_URL = "https://fflqjpakcvvhzrjssyxw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmbHFqcGFrY3Z2aHpyanNzeXh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyMzU4OTUsImV4cCI6MjA1ODgxMTg5NX0._ZubV3IIO14Q4h21W8LckOnIdYlnp6fxwDnyNeI4w6A";

// Create the basic Supabase client
const basicClient = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Export a typed version of the Supabase client
export const supabase = createTypedSupabaseClient(basicClient);
